import React from 'react'
import {
    Modal,
    TransitionablePortal
} from 'semantic-ui-react'
import PropTypes from 'prop-types'

const headerModal = (props) => {
    return (
      <TransitionablePortal
        transition={{ animation: 'scale', duration: 200 }}
        open={props.open}
      >
        <Modal
            open
            onClose={props.handleChangeModal}
            closeIcon
            >
          <Modal.Header>{props.header}</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              {props.children}
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    )
}

headerModal.propTypes = {
    open: PropTypes.bool,
    children: PropTypes.any,
    handleChangeModal: PropTypes.func,
    header: PropTypes.string
}

export default headerModal



// WEBPACK FOOTER //
// ./src/components/HeaderComponent/HeaderModal/HeaderModal.js